import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator';
import type { LalSegmentApi } from '@openx/types/segments';
import { abbreviatedNumber } from '@openx/utils/lib/abbreviatedNumber';
import { useTranslation } from 'react-i18next';
import { MIN_AUC_SCORE_THRESHOLD } from '../../../constants';
import { mapStatus } from '../../utils/mapLalStatus';

export const LalSegmentDetailsSection = ({ lalSegment }: { lalSegment: LalSegmentApi }) => {
  const { t } = useTranslation();

  const status = mapStatus(lalSegment.status);
  const aucScore = lalSegment.auc_score ? abbreviatedNumber(lalSegment.auc_score, { fractionSize: 2 }) : null;

  return (
    <FormSection
      divider
      title={t('Segment Details')}
      description={status && <StatusIndicator status={status.status} label={status.label} />}
    >
      <FieldDetails title={t('Name')} value={lalSegment.lookalike_name} />
      <FieldDetails title={t('LAL Segment ID')} value={lalSegment.id} />
      <FieldDetails
        title={t('LAL Quality Score')}
        value={aucScore}
        titleTooltipText={t(
          "The LAL Quality Score reflects how effectively the model finds users similar to the seed segment. If the score is below {minAucScore}, a LAL segment won't be generated.",
          { minAucScore: MIN_AUC_SCORE_THRESHOLD }
        )}
      />
      <FieldDetails
        title={t('Date Created')}
        value={lalSegment.created_date}
        dateFormat="yyyy-MM-dd"
        showOffset={false}
      />
      <FieldDetails
        title={t('Date Updated')}
        value={lalSegment.updated_date}
        dateFormat="yyyy-MM-dd"
        showOffset={false}
      />
    </FormSection>
  );
};
